import { render, staticRenderFns } from "./BookingFlows.vue?vue&type=template&id=461d9716"
import script from "./BookingFlows.vue?vue&type=script&lang=js"
export * from "./BookingFlows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports